function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, video"
    )
  )
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container, mobileMenu = false, bringBackFocus = false) {
  let first, last

  function updateFocusableElements() {
    const elements = getFocusableElements(container, mobileMenu)
    if (mobileMenu == true) {
      elements.unshift(document.querySelector('button[data-mobile-menu]'))
    }
    first = elements[0]
    last = elements[elements.length - 1]
    console.log(first, last)
  }

  updateFocusableElements()

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return
    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key

    // Update the focusable elements (first and last) in case focusable elements have changed (e.g. modal media slider)
    updateFocusableElements()

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }

    // If not within the container, focus the first element
    if (bringBackFocus && !container.contains(event.target)) {
      first.focus()
    }
  }

  document.addEventListener('keydown', trapFocusHandlers.keydown)
  document.addEventListener('focusin', trapFocusHandlers.focusin)
  if (!bringBackFocus) document.addEventListener('focusout', trapFocusHandlers.focusout)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}
